import 'bootstrap/dist/css/bootstrap.min.css';


import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Container className="mt-5 text-center">
      <Row>
        <Col>
          <h1 className="display-1 error-code">401</h1>
          <h2 className="mb-4">Acceso no autorizado</h2>
          <p className="mb-4">
            Lo sentimos, no tienes permiso para acceder a esta página.
          </p>
          <Button variant="primary" onClick={() => navigate('/')}>
            Volver al inicio
          </Button>
        </Col>
      </Row>
    </Container>
  );
}   
export default Unauthorized;